import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from '../Header';
import { BodyStyled, MainLayoutStyled, MainWrapperStyled } from './styles';
import { ILayoutProps } from './type';

export interface IPrivateLayoutWithNoSidebarProps extends ILayoutProps {
  extraInfo?: any;
}

const PrivateLayoutWithNoSidebar: React.FunctionComponent<
IPrivateLayoutWithNoSidebarProps
> = ({ children, extraInfo }) => {
  return (
    <MainLayoutStyled>
      <Header />
      <BodyStyled $isPublic>
        <MainWrapperStyled $isPublic $noPadding={extraInfo?.noPadding || false}>
          {children || <Outlet />}
        </MainWrapperStyled>
      </BodyStyled>
    </MainLayoutStyled>
  );
};

export default PrivateLayoutWithNoSidebar;
